import styled from 'styled-components';

import { ReactComponent as Close } from 'assets/icons/closeIcon.svg';
import { Document, Page } from '../../../reactPDFConfigured';

export const Wrapper = styled.div`
    background: white;
    width: 100vw;
    height: 100vh;
    background: #525659;
    user-select: none;

    & iframe {
        border: none;
    }
`;

export const Menu = styled.div`
    height: 56px;
    background: #323639;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
`;

export const PageWrapper = styled.div`
    overflow-y: auto;
    display: flex;
    justify-content: center;
    margin: 20px 0;
`;

export const CloseIcon = styled(Close)`
    cursor: pointer;

    & path {
        fill: #fff;
    }
`;

export const CloseIconWrapper = styled.div`
    width: 400px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const FileName = styled.h1`
    font-size: 20px;
    line-height: 24px;
    display: inline-block;
    max-width: 1000px;
    text-overflow: ellipsis;
    font-weight: 500;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
`;

export const ZoomWrapper = styled.div`
    width: 150px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & svg {
        cursor: pointer;
    }
`;

export const ZoomValue = styled.div`
    background: #191b1c;
    color: white;
    font-size: 12px;
    width: 51px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
`;

export const StyledPage = styled(Page)`
    margin: auto;
`;

export const StyledDocument = styled(Document)`
    display: 'flex';
`;
